import { Attribution, StatsType } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
  eventType: StatsType
}

export const getTopSources = ({
  endDate,
  startDate,
  attr,
  eventType,
}: Params) => {
  const statsFields = new Set(['new_visitors', 'views'])
  const where = `WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`

  if (statsFields.has(eventType)) {
    return `SELECT stats.channel_id, channel.name, SUM(stats.${eventType}) FROM source ${where} GROUP BY stats.channel_id, channel.name ORDER BY SUM(stats.${eventType}) DESC LIMIT 6 OFFSET 0`
  }

  const attrPrefix = attr === 'linear' || attr === 'ai' ? `${attr}_source` : attr
  const fetchType  = `${attrPrefix}.${eventType}`

  return `SELECT stats.channel_id, channel.name, SUM(${fetchType}) FROM source ${where} GROUP BY stats.channel_id, channel.name ORDER BY SUM(${fetchType}) DESC LIMIT 6 OFFSET 0`
}
